import ModalAddEditUser from "./modal-add-edit-user";

export default ModalAddEditUser;